<template>
  <div class="fullWidth">
    <div
      v-if="loaded && show"
      class="com-invited-award"
      :style="{
        backgroundColor: pageConfig.backgroundColor,
        backgroundImage: pageConfig.backgroundImage
          ? `url(${pageConfig.backgroundImage})`
          : ''
      }"
    >
      <!--  跑马灯 -->
      <ComponentBox
        :data="rollingStyle"
        :center="true"
        :radius="true"
        style="z-index: 3;"
      >
        <Rolling :data="rollingData" v-if="rollingData.length > 0"></Rolling>
      </ComponentBox>
      <!--  规则按钮  -->
      <ComponentBox :data="ruleStyle">
        <RuleBtn :data="ruleStyle"></RuleBtn>
      </ComponentBox>
      <!--  顶部banner  -->
      <div class="top_banner">
        <img :src="pageConfig.headImage" />
      </div>
      <!-- 资源位 -->
      <ActivityBoard
        v-bind="activityBoardProps"
        :taskCompletion="taskCompletion"
        :isJumpDappWeb="!show"
        v-if="activityBoardProps"
      />
      <!-- 优惠券列表 -->
      <div class="wrapper" v-if="loaded && couponListProps">
        <CouponList
          :couponData="couponData"
          v-bind="couponListProps"
        ></CouponList>
      </div>
      <!-- <div class="bottom_img" v-if="loaded">
      <img src="../../assets/images/invited_page_bottom.png" />
    </div> -->
      <!-- 底部按钮 -->
      <FixedBtn
        v-if="isSameRole"
        @click.native="toHome"
        :data="fixBtnStyle"
      ></FixedBtn>
    </div>
    <div v-if="loaded && !show">正在为您跳转认证页面</div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import { stringifyQuery, getUrlParam } from '@/utils';
import { mapActions } from 'vuex';
import ComponentBox from '../common/ComponentBox';
import FixedBtn from './FixedBtn';
import Rolling from './Rolling';
import RuleBtn from './RuleBtn';
import ActivityBoard from '@/components/templates/common/ActivityBoard';

import { getInvitee, getXLDriverId } from '../../api';
import CouponList from './CouponList';
import { isXL } from '../../utils';
import TokenIn from '@/components/mixins/tokenIn';
import { DRIVER_APP_LINK } from '@/components/templates/helper';
const errorCodeObj = {
  11078: {
    tip: '很遗憾，您不满足受邀条件噢，快去看看其他活动吧'
  },
  11080: {
    tip: '不能自己邀请自己哦',
    redirect: '/',
    query: {
      u: getUrlParam('inviteUserType') || 1,
      bl: getUrlParam('bl'),
      code: getUrlParam('code'),
      tpl: 2
    }
  },
  11081: {
    tip: '您已被其他人邀请了，不能太贪心哦'
  },
  11020: {
    redirect: '/account_error'
  },
  11001: {
    tip: '活动已下线'
  },
  11084: {
    tip: '活动未开始'
  },
  11085: {
    tip: '活动已结束'
  }
  // 11082: {
  //   tip: '很遗憾，不在活动时间内，快去看看其他活动吧'
  // }
};
// import FixedBtn from './FixedBtn';
export default {
  mixins: [TokenIn],
  data() {
    return {
      loaded: false,
      rollingData: [],
      pageConfig: {},
      componentDt: {},
      couponData: [],
      fromUserType: null,
      show: false,
      taskCompletion: null
    };
  },
  beforeRouteLeave(to, from, next) {
    if (to.name == 'login') {
      let query = this.$route.query;
      to.params.user_type = this.user_type;
      to.params.redirectObject = {
        invitationCode: getUrlParam('invitationCode') || 1,
        code: getUrlParam('code'),
        u: getUrlParam('u'),
        bl: getUrlParam('bl'),
        inviteUserType: getUrlParam('inviteUserType'),
        path: `/invited_award?${stringifyQuery(query)}`
      };
    }
    next();
  },
  computed: {
    ruleStyle() {
      return this.componentDt[2008];
    },
    rollingStyle() {
      return this.componentDt[2010];
    },
    fixBtnStyle() {
      return this.componentDt[1054];
    },
    couponListProps() {
      return this.componentDt[1057];
    },
    activityBoardProps() {
      return this.componentDt[2007];
    },
    // 需要修改
    isSameRole() {
      let fromUserType = getUrlParam('inviteUserType') || 1;
      return getUrlParam('u') == fromUserType;
    },
    user_type() {
      return getUrlParam('u') == '1' ? 'user' : 'driver';
    }
  },
  async mounted() {
    this.set_env(this.user_type);
    await this.loadLocationData(true);
    this.trackLog('受邀页', true, {
      actEventType: 'invited_expo'
    });
    let invitationCode = getUrlParam('invitationCode') || 1;
    await this.needLogin('', false, { invitationCode });
    await this.getInviteConf();
  },
  components: {
    Rolling,
    RuleBtn,
    CouponList,
    ComponentBox,
    FixedBtn,
    ActivityBoard
  },
  methods: {
    ...mapMutations('global', ['set_env']),
    ...mapActions('app', ['loadLocationData']),
    getInviteConf() {
      this.$hll.showLoading({ disableLogo: isXL() });
      let inviteeDeviceId = getUrlParam('device_id'),
        inviteeOpenId = getUrlParam('open_id'),
        inviteeVersion = getUrlParam('version'),
        inviterDeviceId = getUrlParam('inviter_device_id'),
        inviterOpenId = getUrlParam('inviter_open_id');
      let params = {
        ...(inviteeDeviceId ? { inviteeDeviceId } : {}),
        ...(inviteeOpenId ? { inviteeOpenId } : {}),
        ...(inviteeVersion ? { inviteeVersion } : {}),
        ...(inviterDeviceId ? { inviterDeviceId } : {}),
        ...(inviterOpenId ? { inviterOpenId } : {})
      };
      return getInvitee(params)
        .then(async data => {
          this.$hll.hideLoading(0);
          data = typeof data == 'object' ? data : {};
          let {
            message,
            rewards,
            errorCode,
            userType,
            isJumpDappWeb,
            taskCompletion
          } = data;
          await this.errorHandle(errorCode);
          let { inviteeInfo, componentObj, inviteeObj } = this.getComponentObj(
            data
          );
          this.show = !isJumpDappWeb;
          this.taskCompletion = taskCompletion;

          if (isJumpDappWeb) {
            let driverId = await getXLDriverId();
            let activity_xl_driver_id = '';
            if (driverId) {
              activity_xl_driver_id = driverId;
              let linkItem = DRIVER_APP_LINK[101];
              const host = location.hostname;
              let isStglinkUrl = /-stg/.test(host);
              let h5Url = '';
              if (linkItem.url) {
                if (isStglinkUrl) {
                  h5Url = linkItem.url.stg;
                } else if (/-pre/.test(host)) {
                  h5Url = linkItem.url.pre;
                } else {
                  h5Url = linkItem.url.prd;
                }
              }
              h5Url = `${h5Url}&driver_id=${activity_xl_driver_id}`;
              location.href = h5Url;
            }
          }
          this.componentDt = componentObj;
          this.pageConfig = inviteeInfo.pageConfig;
          this.rollingData = Array.isArray(message) ? message : [];
          this.couponData = Array.isArray(rewards) ? rewards : [];
          this.loaded = true;
          this.fromUserType = Number(userType);
          /** 初始自定义分享 */
          let {
            shareTitle,
            shareDescription: shareContent,
            shareImage: shareUrl
          } = inviteeObj;
          console.log(inviteeObj, 'inviteeObj');
          this.initShare({ shareUrl, shareTitle, shareContent });
        })
        .catch(({ ret }) => {
          this.$hll.hideLoading(0);
          this.errorHandle(ret);
          this.loaded = true;
        });
    },
    errorHandle(errorCode) {
      return new Promise((resolve, reject) => {
        if (errorCodeObj[errorCode] && errorCode) {
          let { tip, redirect, query: errorQuery } = errorCodeObj[errorCode];
          let query = this.$route.query;
          delete query.invitationCode;
          if (redirect) {
            this.$router.replace({
              path: errorCodeObj[errorCode].redirect,
              query: {
                ...query,
                ...errorQuery
              }
            });
            return reject(false);
          }
          tip && this.$hll.toast(errorCodeObj[errorCode].tip);
        }
        resolve(true);
      });
    },
    checkActTime({ currentTime, startTime, endTime }) {
      if (currentTime < startTime) {
        this.$hll.toast('活动未开始');
      } else if (currentTime > endTime) {
        this.$hll.toast('活动已结束');
      }
    },
    getXlDriverId() {},
    getComponentObj(data) {
      let componentObj = {};
      let inviteeInfo = {};
      let inviteeObj = {};
      try {
        let metaInfo = JSON.parse(data.metaInfo.replace(/[\\]["]/g, '"'));
        inviteeObj = metaInfo.shareConfig;
        inviteeInfo = metaInfo.pages.filter(
          item => item.pageName == 'invitee'
        )[0];
        document.title = inviteeInfo.pageConfig
          ? inviteeInfo.pageConfig.name
          : '';
        inviteeInfo.components.forEach(i => {
          if (i.componentDetail.verticalDistance) {
            i.componentDetail.verticalDistance =
              parseFloat(i.componentDetail.verticalDistance) / 75 + 'rem';
          }
          if (i.componentDetail.horizontalDistance) {
            i.componentDetail.horizontalDistance =
              parseFloat(i.componentDetail.horizontalDistance) / 75 + 'rem';
          }
          componentObj[i.componentTypeId] = i.componentDetail;
        });
      } catch (err) {
        console.error('getComponentObj error', err);
      }
      return { inviteeInfo, componentObj, inviteeObj };
    },
    toRule() {
      this.$router.push('/rule');
    },
    toHome() {
      this.trackLog('受邀页', true, {
        actEventType: 'invited_invite_click',
        invited_role_name: '用户',
        trigger_time: Date.now()
      });
      let query = this.$route.query;
      delete query.invitationCode;

      // 这块写的简直是在糊屎了
      this.$router.push({
        path: '/',
        query: {
          u: getUrlParam('inviteUserType'),
          bl: getUrlParam('bl'),
          code: getUrlParam('code'),
          ...query
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.fullWidth {
  width: 100%;
}
.com-invited-award {
  width: 100%;
  position: relative;
  min-height: 100vh;
  padding-bottom: 200px;
  .wrapper {
    padding: 0px 20px;
    box-sizing: border-box;
  }

  .top_banner,
  .bottom_img {
    img {
      width: 100%;
    }
  }
}
</style>
